import * as Sentry from '@sentry/browser';

if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    dsn: 'https://ffe83cda603442e4b96fe14665216c8f@sentry.io/1367781',
    release: process.env.APP_VERSION,
    replaysSessionSampleRate: 0, // Capture Replays only when an error occurs
    replaysOnErrorSampleRate: 1.0,
    integrations: [
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false
      }),
      Sentry.globalHandlersIntegration({
        onunhandledrejection: false
      })
    ]
  });
}
